import { Component } from "@angular/core";
import { SharedModule } from "../../../../../../shared/shared.module";

@Component({
  selector: "app-cart-drawer",
  templateUrl: "./cart-drawer.component.html",
  imports: [SharedModule],
})
export class CartDrawerComponent {}
